import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/usr/lib/node_modules/workbox-cli/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "css/app.css",
    "revision": "1ba4616002e30d600ff3f664161ff848"
  },
  {
    "url": "favicon.ico",
    "revision": "d41d8cd98f00b204e9800998ecf8427e"
  },
  {
    "url": "index.php",
    "revision": "3b58bff18126a61c142cc576457c82a6"
  },
  {
    "url": "manifest.json",
    "revision": "6ed908589c51e8143f9ebae9cc851b75"
  },
  {
    "url": "mix-manifest.json",
    "revision": "207fd484b7c2ceeff7800b8c8a11b3b6"
  }
], {
  "ignoreURLParametersMatching": [/^utm_/, /^fbclid$/]
});








